import { z } from 'zod';
import { isoDateStringSchema, uuidSchema } from './common';

export const storeDetailsSchema = z.object({
  address: z.string().max(500).optional(),
  url: z.string().url().max(500).optional(),
  phone: z.string().max(50).optional(),
  notes: z.string().max(2000).optional(),
});
export type StoreDetails = z.infer<typeof storeDetailsSchema>;

export const storeSchema = z.object({
  id: uuidSchema,
  ownerSub: z.string().min(1),
  name: z.string().min(1).max(120),
  details: storeDetailsSchema,
  createdAt: isoDateStringSchema,
  updatedAt: isoDateStringSchema,
});
export type Store = z.infer<typeof storeSchema>;

export const createStoreDtoSchema = z.object({
  name: z.string().min(1).max(120),
  details: storeDetailsSchema.optional(),
});
export type CreateStoreDto = z.infer<typeof createStoreDtoSchema>;

export const updateStoreDtoSchema = z
  .object({
    name: z.string().min(1).max(120).optional(),
    details: storeDetailsSchema.optional(),
  })
  .refine((v) => v.name !== undefined || v.details !== undefined, {
    message: 'At least one of name or details must be provided',
  });
export type UpdateStoreDto = z.infer<typeof updateStoreDtoSchema>;
